import withStyles from 'isomorphic-style-loader/withStyles';
import PropTypes from 'prop-types';
import React, { useEffect, useRef, useState } from 'react';
import Button from 'react-bootstrap/lib/Button';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { change, reduxForm } from 'redux-form';

import cx from 'classnames';

// Components
import PlaceGeoSuggest from '../../Common/GeoSuggest/PlaceGeoSuggest';
import DateRange from '../DateRange';
import MobileDateRange from '../MobileDateRange';

// Redux Action
import { setPersonalizedValues } from '../../../actions/personalized';

// Helper
import { locationuploadDir } from '../../../config';
import history from '../../../core/history';
import detectMobileBrowsers from '../../../helpers/detectMobileBrowsers';
import { changeSearchForm, searchFormSuggestSelect } from '../../../helpers/GeoSuggest/updateSearchForm';
import { getPopularLocationAdmin } from '../../../lib/graphql';
import messages from '../../../locale/messages';

import searchIcon from '/public/SiteIcons/searchIconHome.svg';

import calendarIcon from '/public/SiteIcons/calendar.svg';
import locationIcon from '/public/SiteIcons/location.svg';
import peopleIcon from '/public/SiteIcons/people.svg';

import { useQuery } from '@apollo/client';
import bt from '../../commonStyle.css';
import s from './SearchForm.css';

const SearchForm = ({ handleSubmit, isLoading, id, showPersonajeSearch }) => {
  const dispatch = useDispatch();
  const intl = useIntl();

  const personalized = useSelector(state => state.personalized);
  const listingFields = useSelector(state => state.listingFields.data);
  const settingsData = useSelector(state => state.viewListing.settingsData);

  const { data: popularLocationData } = useQuery(getPopularLocationAdmin, {
    ssr: false,
  });

  const [mobileDevice, setMobileDevice] = useState(false);
  const [personCapacity, setPersonCapacity] = useState([]);
  const [smallDevice, setSmallDevice] = useState(false);
  const [verySmallDevice, setVerySmallDevice] = useState(false);
  const [isOneTotalToggle, setIsOneTotalToggle] = useState(false);
  const [activeField, setActiveField] = useState(null);
  const formRef = useRef(null);

  const allFieldsFilled = !!(
    personalized?.location &&
    personalized?.chosen &&
    personalized?.startDate &&
    personalized?.endDate &&
    personalized?.personCapacity
  );
  const showExpanded = activeField || allFieldsFilled;

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (formRef.current && !formRef.current.contains(e.target)) {
        setActiveField(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (detectMobileBrowsers.isMobile()) {
      setMobileDevice(true);
    }

    if (listingFields) {
      setPersonCapacity(listingFields.personCapacity);
    }

    if (personalized?.isOneTotalToggle) {
      setIsOneTotalToggle(true);
    }

    const handleResize = () => {
      setSmallDevice(window.matchMedia('(max-width: 767px)').matches);
      setVerySmallDevice(window.matchMedia('(max-width: 480px)').matches);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [listingFields, personalized]);

  const handleClick = () => {
    let uri = '/s?';

    if (personalized?.chosen) {
      uri += `&address=${personalized.location}&chosen=${personalized.chosen}`;
    } else if (personalized?.location) {
      uri += `&address=${personalized.location}`;
    }

    if (personalized?.startDate && personalized?.endDate) {
      dispatch(setPersonalizedValues({ name: 'isOneTotalToggle', value: true }));
      dispatch(change('SearchForm', 'isOneTotalToggle', true));
      uri += `&startdate=${personalized.startDate}&enddate=${personalized.endDate}`;
    }

    if (personalized?.personCapacity && !isNaN(personalized.personCapacity)) {
      uri += `&guests=${personalized.personCapacity}`;
    }

    history.push(encodeURI(uri));
  };

  const onSuggestSelect = (data, value) => {
    searchFormSuggestSelect({ data, setPersonalizedValues: (payload) => dispatch(setPersonalizedValues(payload)), value, change: (field, val) => dispatch(change('HomeSearchForm', field, val)) });
    setActiveField(null);
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
  };

  const handleFieldClick = (field, inputId) => {
    setActiveField(field);
    if (inputId) {
      const el = document.getElementById(inputId);
      if (el) setTimeout(() => el.focus(), 50);
    }
  };

  const onChange = (value) => {
    if (value === '') {
      changeSearchForm({ setPersonalizedValues: (payload) => dispatch(setPersonalizedValues(payload)), change: (form, field, val) => dispatch(change(form, field, val)) });
    }
  };

  return (
    <div className={cx('layout5Css', s.searchFormWrapper)}>
      <div className={cx('homeSearchForm', 'verticalsearchform', 'layout5Searchform')} ref={formRef}>
        <div className={cx(s.searchForm, 'searchForm', { [s.formHasActive]: activeField })}>
          <div
            className={cx(
              'tableCellRTL', 'layout5DateWidth',
              s.GeoSuggestMobileFormItem, s.sideBorder, 'sideBorder', 'geoSuggestSideBorder',
              s.fieldWrapper,
              { [s.fieldActive]: activeField === 'location', [s.fieldInactive]: activeField && activeField !== 'location' }
            )}
            onClick={(e) => {
              // El click en un item del suggest no debe reabrir el popover:
              // viene en burbuja desde PlaceGeoSuggest y haría focus + setActiveField('location')
              if (e.target.closest?.('.manualGeoSuggestListWrapper, .popularLocationsDropdown')) {
                return;
              }
              handleFieldClick('location', 'homeSearch' + id);
            }}
          >
            <label className={cx(s.label, s.whereLabelPadding)}>
              <span><FormattedMessage {...messages.where} /></span>
            </label>
            <PlaceGeoSuggest
              placeholder={intl.formatMessage(messages.homeWhere)}
              className={cx(s.formControlInput, s.layout2LocationSuggestInput, s.input, 'newGeoSuggestInput', s.textEllipsis)}
              id={'homeSearch' + id}
              initialValue={personalized?.location}
              onChange={onChange}
              onSuggestSelect={onSuggestSelect}
              containerClass="layoutTwoAndFiveGeoSuggest"
              popularLocations={popularLocationData?.getPopularLocationAdmin}
              locationuploadDir={locationuploadDir}
            />
            <img src={locationIcon} className={s.inputIcon} alt="" />
          </div>
          <div
            className={cx(
              'layout5SearchformLocationTwo', 'layout5DateWidth',
              s.mobileFormItem, s.sideBorder, 'sideBorder',
              s.fieldWrapper,
              { [s.fieldActive]: activeField === 'dates', [s.fieldInactive]: activeField && activeField !== 'dates' }
            )}
            onClick={() => handleFieldClick('dates', null)}
          >
            <label className={cx(s.label, s.dateLabel)}>
              <span><FormattedMessage {...messages.when} /></span>
            </label>
            <span className={cx('homeDate', s.formControlInput, s.input, 'homeDateAR', 'homeSerachDate')}>
              {!smallDevice ? (
                <DateRange formName={'HomeSearchForm'} numberOfMonths={2} isLoading={isLoading} />
              ) : (
                <MobileDateRange formName={'HomeSearchForm'} numberOfMonths={1} isLoading={isLoading} />
              )}
            </span>
            <img src={calendarIcon} className={s.inputIcon} alt="" />
          </div>
          <div
            className={cx(
              s.mobileFormItem,
              s.fieldWrapper,
              { [s.fieldActive]: activeField === 'guests', [s.fieldInactive]: activeField && activeField !== 'guests' }
            )}
            onClick={() => handleFieldClick('guests', 'guestSelect' + id)}
          >
            <label className={cx(s.selectPadding, s.label, 'inputSpace')}>
              <span><FormattedMessage {...messages.guest} /></span>
            </label>
            <div className={s.guestCounter}>
              <button
                type="button"
                className={s.counterBtn}
                onClick={() => {
                  const current = personalized?.personCapacity || 1;
                  if (current > 1) {
                    dispatch(setPersonalizedValues({ name: 'personCapacity', value: current - 1 }));
                  }
                }}
                disabled={(personalized?.personCapacity || 1) <= 1}
              >
                −
              </button>
              <span className={s.counterValue}>
                {personalized?.personCapacity || 1} {((personalized?.personCapacity || 1) > 1) ? personCapacity?.[0]?.otherItemName : personCapacity?.[0]?.itemName}
              </span>
              <button
                type="button"
                className={s.counterBtn}
                onClick={() => {
                  const current = personalized?.personCapacity || 1;
                  if (current < 20) {
                    dispatch(setPersonalizedValues({ name: 'personCapacity', value: current + 1 }));
                  }
                }}
                disabled={(personalized?.personCapacity || 1) >= 20}
              >
                +
              </button>
            </div>
            <img src={peopleIcon} className={s.inputIcon} alt="" />
          </div>
          <div className={s.buttonContainer}>
            <Button className={cx(bt.btnPrimary, s.btnBlock, s.searchButton, 'layOut5SearchBtn', { [s.btnExpanded]: showExpanded })} onClick={handleClick}>
              <img src={searchIcon} alt="Search" />
              {/* {showExpanded && <span><FormattedMessage {...messages.search} /></span>} */}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

SearchForm.propTypes = {
  handleSubmit: PropTypes.func,
  isLoading: PropTypes.bool,
  id: PropTypes.any,
  showPersonajeSearch: PropTypes.bool
};

export default reduxForm({
  form: 'HomeSearchForm',
})(withStyles(s, bt)(SearchForm));
